import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import upperFirst from 'lodash.upperfirst';

import ContentSection from 'components/ContentSection';

import { getCurrencyTypeInURLFormat } from 'utils';

import { Title, LinksList, LinkItem } from './styles';

const CurrenciesLinks = memo(({ source, currencies }) => (
  <ContentSection as="section">
    <Title as="h2">
      <FormattedMessage
        id="currencyLanding.linksSectionTitle"
        values={{ currency: source.nameG || source.name }}
      />
    </Title>

    <LinksList>
      {currencies.map(({ name, nameAcc, slug, type }) => {
        const sourceSlug = `${(
          source.slug || ''
        ).toLowerCase()}${getCurrencyTypeInURLFormat(source.type)}`;
        const targetSlug = `${slug.toLowerCase()}${getCurrencyTypeInURLFormat(
          type
        )}`;
        const link = `/converter/${sourceSlug}-${targetSlug}/`;

        return (
          <LinkItem key={name} href={link} to={link}>
            {`${upperFirst(source.name)} в ${nameAcc || name || slug}`}
          </LinkItem>
        );
      })}
    </LinksList>
  </ContentSection>
));

CurrenciesLinks.propTypes = {
  source: PropTypes.objectOf(PropTypes.string).isRequired,
  currencies: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default CurrenciesLinks;
